import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Button } from './ui/button';
import { Menu, X, MessageCircle } from 'lucide-react';

const Navbar = () => {
  const location = useLocation();
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const navLinks = [
    { name: 'AI Image', path: '/ai-image', comingSoon: false },
    { name: 'AI Video', path: null, comingSoon: true },
  ];

  return (
    <nav className="fixed top-0 left-0 right-0 z-50 bg-[#0a0a0a]/95 backdrop-blur-sm border-b border-white/5">
      <div className="max-w-7xl mx-auto px-6 py-4">
        <div className="flex items-center justify-between">
          {/* Logo */}
          <Link to="/" className="flex items-center space-x-2">
            <div className="w-8 h-8 bg-gradient-to-br from-yellow-400 to-yellow-600 rounded-lg flex items-center justify-center">
              <span className="text-black font-bold text-xl">P</span>
            </div>
            <span className="text-white text-2xl font-semibold tracking-tight">pulse-chat</span>
          </Link>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center space-x-8">
            {navLinks.map((link) => (
              link.path ? (
                <Link
                  key={link.path}
                  to={link.path}
                  className={`text-sm font-medium transition-colors hover:text-yellow-400 ${
                    location.pathname === link.path ? 'text-yellow-400' : 'text-white/80'
                  }`}
                >
                  {link.name}
                </Link>
              ) : (
                <div
                  key={link.name}
                  className="flex items-center space-x-2"
                >
                  <Link
                    to="/ai-video"
                    className="text-sm font-medium text-white/80 hover:text-yellow-400 transition-colors"
                  >
                    {link.name}
                  </Link>
                  <span className="text-xs px-2 py-0.5 bg-yellow-400/10 text-yellow-400 rounded-full border border-yellow-400/20">
                    Coming Soon
                  </span>
                </div>
              )
            ))}
            <a
              href="https://pulse-chat.pro/chat.php"
              className="flex items-center space-x-1 text-sm font-medium text-white/80 hover:text-yellow-400 transition-colors"
            >
              <MessageCircle size={16} />
              <span>Chat</span>
            </a>
          </div>

          {/* CTA Button */}
          <div className="hidden md:flex items-center space-x-4">
            <Link to="/ai-image">
              <Button 
                className="bg-[#F4D03F] hover:bg-[#e5c230] text-black font-semibold px-6 py-2 rounded-full transition-all duration-300 hover:scale-105"
              >
                Start Now
              </Button>
            </Link>
          </div>

          {/* Mobile Menu Button */}
          <button
            className="md:hidden text-white"
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
          >
            {mobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>

        {/* Mobile Menu */}
        {mobileMenuOpen && (
          <div className="md:hidden mt-4 pb-4 space-y-3">
            {navLinks.map((link) => (
              link.path ? (
                <Link
                  key={link.path}
                  to={link.path}
                  className="block text-white/80 hover:text-yellow-400 transition-colors py-2"
                  onClick={() => setMobileMenuOpen(false)}
                >
                  {link.name}
                </Link>
              ) : (
                <div
                  key={link.name}
                  className="flex items-center justify-between py-2"
                >
                  <Link
                    to="/ai-video"
                    className="text-white/80 hover:text-yellow-400 transition-colors"
                    onClick={() => setMobileMenuOpen(false)}
                  >
                    {link.name}
                  </Link>
                  <span className="text-xs px-2 py-0.5 bg-yellow-400/10 text-yellow-400 rounded-full border border-yellow-400/20">
                    Coming Soon
                  </span>
                </div>
              )
            ))}
            <a
              href="https://pulse-chat.pro/chat.php"
              className="flex items-center space-x-1 text-white/80 hover:text-yellow-400 transition-colors py-2"
              onClick={() => setMobileMenuOpen(false)}
            >
              <MessageCircle size={16} />
              <span>Chat</span>
            </a>
            <Link to="/ai-image">
              <Button className="w-full bg-[#F4D03F] hover:bg-[#e5c230] text-black font-semibold">
                Start Now
              </Button>
            </Link>
          </div>
        )}
      </div>
    </nav>
  );
};

export default Navbar;